import { render, staticRenderFns } from "./FeaturesAndFunctionsSection.vue?vue&type=template&id=2d4614f6&scoped=true&"
import script from "./FeaturesAndFunctionsSection.vue?vue&type=script&lang=js&"
export * from "./FeaturesAndFunctionsSection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesAndFunctionsSection.vue?vue&type=style&index=0&id=2d4614f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4614f6",
  null
  
)

export default component.exports